// @ts-nocheck
import React from 'react';
import { ApplyPluginsType } from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';

export function getRoutes() {
  const routes = [
  {
    "path": "/datalab/iframe",
    "component": require('@/pages/datalab/pages/IframePage/index').default,
    "wrappers": [require('@/pages/datalab/pages/IframePage/IframeGuard').default],
    "routes": [
      {
        "path": "/datalab/iframe/report",
        "component": require('@/pages/datalab/pages/IframePage/IframeReport').default,
        "exact": true
      },
      {
        "path": "/datalab/iframe/explore",
        "component": require('@/pages/datalab/pages/Multidimensional/Analysis/index').default,
        "exact": true
      }
    ]
  },
  {
    "path": "/datalab/download",
    "component": require('@/pages/intelligence/pages/Download/index').default,
    "exact": true
  },
  {
    "path": "/strategic/DocPreviewer",
    "component": require('@/pages/strategic/pages/COSPreviewers').default,
    "exact": true
  },
  {
    "path": "/agent/iframe",
    "component": require('@/pages/aigc/pages/Agent/ChatIWiki/index.tsx').default,
    "exact": true
  },
  {
    "path": "/access-code-login",
    "component": require('@/pages/home/pages/accessCodeLogin').default,
    "exact": true
  },
  {
    "component": require('@/layouts/index').default,
    "routes": [
      {
        "path": "/login",
        "component": require('@/pages/home/pages/login').default,
        "exact": true
      },
      {
        "path": "/login/thirdPartyLogin",
        "component": require('@/pages/home/pages/thirdPartyLogin').default,
        "exact": true
      },
      {
        "path": "/intelligence_detail",
        "component": require('@/pages/home/pages/redirect').default,
        "exact": false
      },
      {
        "path": "/v1/opinion",
        "redirect": "/opinion",
        "exact": false
      },
      {
        "path": "/v1/dashboard",
        "redirect": "/dashboard",
        "exact": false
      },
      {
        "path": "/v1/datalab",
        "redirect": "/datalab",
        "exact": false
      },
      {
        "path": "/v1/g-pop",
        "redirect": "/g-pop",
        "exact": false
      },
      {
        "path": "/v1/home",
        "redirect": "/home",
        "exact": false
      },
      {
        "path": "/v1/Home/Explore",
        "redirect": "/home",
        "exact": false
      },
      {
        "path": "/Home/Explore",
        "redirect": "/home",
        "exact": true
      },
      {
        "path": "/g-pop/Pipeline/Dashboard",
        "redirect": "/g-pop/Pipeline/Overview",
        "exact": true
      },
      {
        "path": "/home",
        "component": require('@/pages/home/pages/home/index').default,
        "exact": true
      },
      {
        "path": "/",
        "redirect": "/home",
        "exact": true
      },
      {
        "path": "/search",
        "component": require('@/pages/home/layouts/index').default,
        "routes": [
          {
            "path": "/search/",
            "component": require('@/pages/home/pages/search/index').default,
            "exact": true
          }
        ]
      },
      {
        "path": "/chatgpt",
        "component": require('@/pages/home/layouts/index').default,
        "routes": [
          {
            "path": "/chatgpt/",
            "component": require('@/pages/home/pages/chatgpt').default,
            "exact": true
          }
        ]
      },
      {
        "path": "/test/datepicker",
        "component": require('@/pages/home/layouts/index').default,
        "routes": [
          {
            "path": "/test/datepicker/",
            "component": require('@/pages/home/pages/test/DatePicker').default,
            "exact": true
          }
        ]
      },
      {
        "path": "/region-select",
        "component": require('@/pages/home/layouts/index').default,
        "routes": [
          {
            "path": "/region-select/",
            "component": require('@/pages/home/pages/region-select').default,
            "exact": true
          }
        ]
      },
      {
        "path": "/aigallery/home",
        "component": require('@/pages/home/pages/AIGallery/index').default,
        "exact": true
      },
      {
        "path": "/aigallery/report",
        "component": require('@/pages/home/pages/AIGalleryReport/index').default,
        "exact": true
      },
      {
        "path": "/gamewiki",
        "component": require('@/pages/home/pages/GameWiki/index').default,
        "exact": false
      },
      {
        "path": "/studio",
        "component": require('@/pages/home/pages/studio/index').default,
        "exact": true
      },
      {
        "path": "/studio/:studioId",
        "component": require('@/pages/home/pages/studio/layout/index').default,
        "routes": [
          {
            "path": "/studio/:studioId/home",
            "component": require('@/pages/home/pages/studio/components/StudioWrap/index').default,
            "routes": [
              {
                "path": "/studio/:studioId/home/:tab?",
                "component": require('@/pages/home/pages/studio/home').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/studio/:studioId/pr",
            "component": require('@/pages/home/pages/studio/components/StudioWrap/index').default,
            "routes": [
              {
                "path": "/studio/:studioId/pr/:gameCode",
                "component": require('@/pages/home/pages/studio/pr').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/pr/:gameCode/:_rest*",
                "component": require('@/pages/home/pages/studio/pr').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/pr/",
                "component": require('@/pages/home/pages/studio/pr').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/studio/:studioId/ai",
            "redirect": "/studio/:studioId/ai-report",
            "exact": true
          },
          {
            "path": "/studio/:studioId/ai-report",
            "component": require('@/pages/home/pages/studio/components/StudioWrap/index').default,
            "routes": [
              {
                "path": "/studio/:studioId/ai-report/",
                "component": require('@/pages/home/pages/studio/ai').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/studio/:studioId/databrainLink",
            "component": require('@/pages/home/pages/studio/components/StudioWrap/index').default,
            "routes": [
              {
                "path": "/studio/:studioId/databrainLink/:linkKey?",
                "component": require('@/pages/home/pages/studio/databrainLink').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/studio/:studioId/:gameCode/operation/:pageMenu?",
            "component": require('@/pages/home/pages/studio/components/GameWrap/index').default,
            "routes": [
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/tableau/report/:reportId",
                "component": require('@/pages/home/pages/studio/tableau').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/preset/report/:reportId",
                "component": require('@/pages/home/pages/studio/preset').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/pdf/report/:reportId",
                "component": require('@/pages/home/pages/studio/pdf').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/datalab/report/:reportId?",
                "component": require('@/pages/home/pages/studio/datalab').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/datalab/customDashboard/:dashboardId",
                "component": require('@/pages/home/pages/studio/datalab').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/looker/report/:reportId",
                "component": require('@/pages/home/pages/studio/looker').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/authPath/report/:reportId",
                "component": require('@/pages/home/pages/studio/authPath').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/competitors",
                "component": require('@/pages/home/pages/studio/competitors').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/inGameAnalytics",
                "component": require('@/pages/home/pages/studio/inGameAnalytics').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/reports",
                "component": require('@/pages/home/pages/studio/reports').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/opinions",
                "component": require('@/pages/home/pages/studio/opinions/index').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/opinions-v2",
                "component": require('@/pages/home/pages/studio/opinions/indexV2').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/opinionIndex",
                "component": require('@/pages/home/pages/studio/opinions/opinionIndex').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/cbt",
                "component": require('@/pages/home/pages/studio/CBT/index').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/multiReports/:reportKey?",
                "component": require('@/pages/home/pages/studio/MultiReports/index').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/potentialMarket",
                "component": require('@/pages/home/pages/studio/potentialMarket/index').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/presentation",
                "component": require('@/pages/home/pages/studio/presentation/index').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/socialIndex",
                "component": require('@/pages/home/pages/studio/socialIndex').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/gtdrAssessment",
                "component": require('@/pages/home/pages/studio/gtdrAssessment').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/paidkol",
                "component": require('@/pages/home/pages/studio/paidkol').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/adCreatives",
                "component": require('@/pages/home/pages/studio/AdCreatives').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/creativeTrends",
                "component": require('@/pages/home/pages/studio/creativeTrends').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/trendingPostsVdieo",
                "component": require('@/pages/home/pages/studio/TrendingPostsVdieo').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/influencer",
                "component": require('@/pages/home/pages/studio/Influencer').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/studioAssessment",
                "component": require('@/pages/home/pages/studio/studioAssessment').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/web/report/:reportId",
                "component": require('@/pages/home/pages/studio/web').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/operation/:pageMenu?/databrainLink/:linkKey?",
                "component": require('@/pages/home/pages/studio/databrainLink').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/studio/:studioId/:gameCode/development/:pageMenu?",
            "component": require('@/pages/home/pages/studio/components/GameWrap/index').default,
            "routes": [
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/tableau/report/:reportId",
                "component": require('@/pages/home/pages/studio/tableau').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/preset/report/:reportId",
                "component": require('@/pages/home/pages/studio/preset').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/pdf/report/:reportId",
                "component": require('@/pages/home/pages/studio/pdf').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/datalab/report/:reportId?",
                "component": require('@/pages/home/pages/studio/datalab').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/datalab/customDashboard/:dashboardId",
                "component": require('@/pages/home/pages/studio/datalab').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/looker/report/:reportId",
                "component": require('@/pages/home/pages/studio/looker').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/authPath/report/:reportId",
                "component": require('@/pages/home/pages/studio/authPath').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/competitors",
                "component": require('@/pages/home/pages/studio/competitors').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/inGameAnalytics",
                "component": require('@/pages/home/pages/studio/inGameAnalytics').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/reports",
                "component": require('@/pages/home/pages/studio/reports').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/opinions",
                "component": require('@/pages/home/pages/studio/opinions/index').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/opinions-v2",
                "component": require('@/pages/home/pages/studio/opinions/indexV2').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/opinionIndex",
                "component": require('@/pages/home/pages/studio/opinions/opinionIndex').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/cbt",
                "component": require('@/pages/home/pages/studio/CBT/index').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/multiReports/:reportKey?",
                "component": require('@/pages/home/pages/studio/MultiReports/index').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/potentialMarket",
                "component": require('@/pages/home/pages/studio/potentialMarket/index').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/presentation",
                "component": require('@/pages/home/pages/studio/presentation/index').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/socialIndex",
                "component": require('@/pages/home/pages/studio/socialIndex').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/gtdrAssessment",
                "component": require('@/pages/home/pages/studio/gtdrAssessment').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/paidkol",
                "component": require('@/pages/home/pages/studio/paidkol').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/adCreatives",
                "component": require('@/pages/home/pages/studio/AdCreatives').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/creativeTrends",
                "component": require('@/pages/home/pages/studio/creativeTrends').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/trendingPostsVdieo",
                "component": require('@/pages/home/pages/studio/TrendingPostsVdieo').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/influencer",
                "component": require('@/pages/home/pages/studio/Influencer').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/studioAssessment",
                "component": require('@/pages/home/pages/studio/studioAssessment').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/web/report/:reportId",
                "component": require('@/pages/home/pages/studio/web').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode/development/:pageMenu?/databrainLink/:linkKey?",
                "component": require('@/pages/home/pages/studio/databrainLink').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/studio/:studioId/:gameCode?/:pageMenu?",
            "component": require('@/pages/home/pages/studio/components/GameWrap/index').default,
            "routes": [
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/tableau/report/:reportId",
                "component": require('@/pages/home/pages/studio/tableau').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/preset/report/:reportId",
                "component": require('@/pages/home/pages/studio/preset').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/pdf/report/:reportId",
                "component": require('@/pages/home/pages/studio/pdf').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/datalab/report/:reportId?",
                "component": require('@/pages/home/pages/studio/datalab').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/datalab/customDashboard/:dashboardId",
                "component": require('@/pages/home/pages/studio/datalab').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/looker/report/:reportId",
                "component": require('@/pages/home/pages/studio/looker').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/authPath/report/:reportId",
                "component": require('@/pages/home/pages/studio/authPath').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/competitors",
                "component": require('@/pages/home/pages/studio/competitors').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/inGameAnalytics",
                "component": require('@/pages/home/pages/studio/inGameAnalytics').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/reports",
                "component": require('@/pages/home/pages/studio/reports').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/opinions",
                "component": require('@/pages/home/pages/studio/opinions/index').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/opinions-v2",
                "component": require('@/pages/home/pages/studio/opinions/indexV2').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/opinionIndex",
                "component": require('@/pages/home/pages/studio/opinions/opinionIndex').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/cbt",
                "component": require('@/pages/home/pages/studio/CBT/index').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/multiReports/:reportKey?",
                "component": require('@/pages/home/pages/studio/MultiReports/index').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/potentialMarket",
                "component": require('@/pages/home/pages/studio/potentialMarket/index').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/presentation",
                "component": require('@/pages/home/pages/studio/presentation/index').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/socialIndex",
                "component": require('@/pages/home/pages/studio/socialIndex').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/gtdrAssessment",
                "component": require('@/pages/home/pages/studio/gtdrAssessment').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/paidkol",
                "component": require('@/pages/home/pages/studio/paidkol').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/adCreatives",
                "component": require('@/pages/home/pages/studio/AdCreatives').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/creativeTrends",
                "component": require('@/pages/home/pages/studio/creativeTrends').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/trendingPostsVdieo",
                "component": require('@/pages/home/pages/studio/TrendingPostsVdieo').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/influencer",
                "component": require('@/pages/home/pages/studio/Influencer').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/studioAssessment",
                "component": require('@/pages/home/pages/studio/studioAssessment').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/web/report/:reportId",
                "component": require('@/pages/home/pages/studio/web').default,
                "exact": true
              },
              {
                "path": "/studio/:studioId/:gameCode?/:pageMenu?/databrainLink/:linkKey?",
                "component": require('@/pages/home/pages/studio/databrainLink').default,
                "exact": true
              }
            ]
          }
        ]
      },
      {
        "path": "/dashboard/game/:gamecode/datalab/chart/explore",
        "component": require('@/pages/datalab/pages/Multidimensional/Analysis/index').default,
        "exact": true
      },
      {
        "path": "/dashboard/game/:gamecode/authEmbed",
        "component": require('@/pages/dashboard/pages/authEmbed').default,
        "exact": true
      },
      {
        "path": "/dashboard",
        "component": require('@/pages/dashboard/layouts/index').default,
        "routes": [
          {
            "path": "/dashboard/:type/:gamecode",
            "routes": [
              {
                "path": "/dashboard/:type/:gamecode/forecast",
                "component": require('@/pages/dashboard/pages/forecast').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/looker/demo",
                "component": require('@/pages/dashboard/pages/looker').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/looker/Login-Funnel",
                "component": require('@/pages/dashboard/pages/looker').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/looker/explore",
                "component": require('@/pages/dashboard/pages/looker').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/looker/report/:reportId",
                "component": require('@/pages/dashboard/pages/looker').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/powerbi/demo",
                "component": require('@/pages/dashboard/pages/powerbi').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/powerbi/simple",
                "component": require('@/pages/dashboard/pages/powerbi/simple').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/authPath/report/:reportId",
                "component": require('@/pages/dashboard/pages/auth').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/web/report/:reportId",
                "component": require('@/pages/dashboard/pages/web').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/tableau/report/:reportId",
                "component": require('@/pages/dashboard/pages/tableau').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/preset/report/:reportId",
                "component": require('@/pages/dashboard/pages/preset').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/pdf/report/:reportId",
                "component": require('@/pages/dashboard/pages/pdf').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/cos/report/:reportId",
                "component": require('@/pages/dashboard/pages/cos').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/dashApp/report/:reportId",
                "component": require('@/pages/dashboard/pages/dashApp').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/overview/daily/:tab?",
                "component": require('@/pages/dashboard/pages/overview/daily').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/dataTest/card",
                "component": require('@/pages/dashboard/pages/dataTest/card').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/sth/worldmap",
                "component": require('@/pages/dashboard/pages/sth/newWorldMap/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/sth/oldWorldmap",
                "component": require('@/pages/dashboard/pages/sth/worldMap/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/sth/matrix",
                "component": require('@/pages/dashboard/pages/sth/matrix/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/overview/versionDaily",
                "component": require('@/pages/dashboard/pages/overview/versionDaily').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/overview/xh-daily",
                "component": require('@/pages/dashboard/pages/overview/dailyXh').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/overview/acc-daily",
                "component": require('@/pages/dashboard/pages/overview/dailyAcc').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/overview/lifetime",
                "component": require('@/pages/dashboard/pages/overview/lifetime').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/wow/index",
                "component": require('@/pages/dashboard/pages/wow/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/changeAnalysis",
                "component": require('@/pages/dashboard/pages/changeAnalysis').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/dauByRegion",
                "component": require('@/pages/dashboard/pages/dauByRegion').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/benchmark/explore",
                "component": require('@/pages/dashboard/pages/benchmark/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/report/abnormalReport",
                "component": require('@/pages/dashboard/pages/abnormalReport/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/benchmark/gtdrAssessment",
                "component": require('@/pages/dashboard/pages/benchmark/gtdrAssessment').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/overview/pcConsoleDailyV2/:tab?",
                "component": require('@/pages/dashboard/pages/overview/pcConsoleDailyV2').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/overview/pcConsoleDailyV3/:tab?",
                "component": require('@/pages/dashboard/pages/overview/pcConsoleDailyV3').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/overview/pcConsoleWeekly/:tab?",
                "component": require('@/pages/dashboard/pages/overview/pcConsoleWeekly').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/overview/pcConsoleWeekV2/:tab?",
                "component": require('@/pages/dashboard/pages/overview/pcConsoleWeeklyV2').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/overview/pcConsoleMonthly/:tab?",
                "component": require('@/pages/dashboard/pages/overview/pcConsoleMonthly').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/overview/pcConsoleMonthV2/:tab?",
                "component": require('@/pages/dashboard/pages/overview/pcConsoleMonthlyV2').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/overview/kpi",
                "component": require('@/pages/dashboard/pages/overview/kpiOverview').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/overview/weekly/:tab?",
                "component": require('@/pages/dashboard/pages/overview/weekly').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/overview/monthly/:tab?",
                "component": require('@/pages/dashboard/pages/overview/monthly').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/overview/xh-monthly",
                "component": require('@/pages/dashboard/pages/overview/monthXh').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/overview/dataRange",
                "component": require('@/pages/dashboard/pages/overview/dataRange').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/engagement/churn/index",
                "component": require('@/pages/dashboard/pages/engagement/churn/Nightingale/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/comparison/DateComparison/index",
                "component": require('@/pages/dashboard/pages/comparison/dateComparison/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/realtime/users/:tab?",
                "component": require('@/pages/dashboard/pages/realtime/realtimeUsers/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/realtime/new/revenue",
                "component": require('@/pages/dashboard/pages/realtime/revenuev2/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/realtime/nightingaleUsers/:tab?",
                "component": require('@/pages/dashboard/pages/realtime/realtimeUsers/realtimeUsersNightingale/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/engagement/register/:tab?",
                "component": require('@/pages/dashboard/pages/engagement/new/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/realtime/revenue/:tab?",
                "component": require('@/pages/dashboard/pages/realtime/revenue/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/realtime/steam",
                "component": require('@/pages/dashboard/pages/realtime/steam/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/realtime/sales/:tab?",
                "component": require('@/pages/dashboard/pages/realtime/steamSales/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/realtime/steamCCU/:tab?",
                "component": require('@/pages/dashboard/pages/realtime/steamCCU/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/realtime/baseSales/:tab?",
                "component": require('@/pages/dashboard/pages/realtime/baseSales/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/realtime/uaSpend/:tab?",
                "component": require('@/pages/dashboard/pages/realtime/uaSpend/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/realtime/iaaRevenue/:tab?",
                "component": require('@/pages/dashboard/pages/realtime/iaaRevenue/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/realtime/overview/:tab?",
                "component": require('@/pages/dashboard/pages/realtime/overview/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/retention/index/:tab?",
                "component": require('@/pages/dashboard/pages/engagement/retention/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/engagement/lt",
                "component": require('@/pages/dashboard/pages/engagement/lt/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/retention/nightingale/:tab?",
                "component": require('@/pages/dashboard/pages/engagement/retention/Nightingale').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/engagement/rollingRetention/:tab?",
                "component": require('@/pages/dashboard/pages/engagement/rollingRetention/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/engagement/rateReturn/:tab?",
                "component": require('@/pages/dashboard/pages/engagement/returnV2/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/engagement/return",
                "component": require('@/pages/dashboard/pages/engagement/return/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/engagement/churn/:tab?",
                "component": require('@/pages/dashboard/pages/engagement/churn/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/engagement/active/:tab?",
                "component": require('@/pages/dashboard/pages/engagement/active/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/monetization/revenue/:tab?",
                "component": require('@/pages/dashboard/pages/monetization/revenue').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/monetization/salesOverview/:tab?",
                "component": require('@/pages/dashboard/pages/monetization/SalesOverview/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/monetization/salesBreakdown",
                "component": require('@/pages/dashboard/pages/monetization/SalesBreakdown/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/monetization/inGameRevenue/:tab?",
                "component": require('@/pages/dashboard/pages/monetization/ingameRevenue').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/monetization/inGameRevenueMerge/:tab?",
                "component": require('@/pages/dashboard/pages/monetization/ingameRevenue/merge').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/monetization/ltv",
                "component": require('@/pages/dashboard/pages/monetization/ltv').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/monetization/adFunnel",
                "component": require('@/pages/dashboard/pages/monetization/adFunnel').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/comparisonAnalysis/dateComparison/:tab?",
                "component": require('@/pages/dashboard/pages/comparison/dateComparison/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/comparisonAnalysis/eventComparison",
                "component": require('@/pages/dashboard/pages/comparison/eventComparison/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/comparisonAnalysis/countryComparison",
                "component": require('@/pages/dashboard/pages/comparison/countryComparison/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/ua/spend",
                "component": require('@/pages/dashboard/pages/ua/spend').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/ua/noSpend",
                "component": require('@/pages/dashboard/pages/ua/noSpend').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/competitor/index/:tab?",
                "component": require('@/pages/dashboard/pages/competitor/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/competitor/xh-index/:tab?",
                "component": require('@/pages/dashboard/pages/competitor/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/subscribe/subscribeManage",
                "component": require('@/pages/dashboard/pages/subscribe/subscribeManage').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/subscribe/subscribeRecord",
                "component": require('@/pages/dashboard/pages/subscribe/subscribeRecord').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/subscribe/subscribeSetting",
                "component": require('@/pages/dashboard/pages/subscribe/subscribeSetting').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/multiTimezone/dailyTimezone/:timezonetype",
                "component": require('@/pages/dashboard/pages/multiTimezone/dailyByTimezone').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/multiTimezone/newUsers/:timezonetype",
                "component": require('@/pages/dashboard/pages/multiTimezone/newUsersRetention').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/eventAnalysis/eventDetails",
                "component": require('@/pages/dashboard/pages/eventAnalysis/EventDetails/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/eventAnalysis/eventAnalysis",
                "component": require('@/pages/dashboard/pages/eventAnalysis/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/eventAnalysis/eventExploration",
                "component": require('@/pages/dashboard/pages/eventAnalysis/EventExploration/index').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/performance/overall/:tab?",
                "component": require('@/pages/dashboard/pages/performance').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/funnel/registerFunnel",
                "component": require('@/pages/dashboard/pages/funnel/registerFunnel').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/funnel/pc/registerFunnel",
                "component": require('@/pages/dashboard/pages/funnel/registerFunnelPC').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/funnel/steam/registerFunnel",
                "component": require('@/pages/dashboard/pages/funnel/registerFunnelSteam').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/funnel/epic/registerFunnel",
                "component": require('@/pages/dashboard/pages/funnel/registerFunnelEpic').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/funnel/ps/registerFunnel",
                "component": require('@/pages/dashboard/pages/funnel/registerFunnelPS').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/funnel/xbox/registerFunnel",
                "component": require('@/pages/dashboard/pages/funnel/registerFunnelXbox').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/funnel/registerFunnelDaily",
                "component": require('@/pages/dashboard/pages/funnel/registerFunnelDaily').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/intlsdk/successRateAndErrorCode",
                "component": require('@/pages/dashboard/pages/intlsdk/ErrorCode').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/comp",
                "component": require('@/pages/dashboard/pages/commingSoon').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/rfmModel",
                "component": require('@/pages/dashboard/pages/commingSoon').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/datalab/report/:dashboardid?",
                "component": require('@/pages/dashboard/pages/datalab/ReportAnalysis').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/pvp/speed",
                "component": require('@/pages/dashboard/pages/pvp/speed').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/test/filter",
                "component": require('@/pages/dashboard/pages/testPage/filter').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/datalab/customDashboard/:dashboardId",
                "component": require('@/pages/dashboard/pages/datalab/CustomDashboard').default,
                "exact": true
              },
              {
                "path": "/dashboard/:type/:gamecode/:module/:report/:tab?",
                "component": require('@/pages/dashboard/pages/configurationPage/index').default,
                "exact": false
              }
            ]
          },
          {
            "path": "/dashboard/",
            "component": require('@/pages/dashboard/pages/index').default,
            "exact": true
          }
        ]
      },
      {
        "path": "/unSubscribe",
        "component": require('@/pages/dashboard/pages/subscribe/unSubscribeResult').default,
        "exact": true
      },
      {
        "path": "/datalab/embedded",
        "component": require('@/pages/datalab/pages/EmbeddedReportPage/index').default,
        "exact": true
      },
      {
        "path": "/datalab",
        "component": require('@/pages/datalab/layouts/index').default,
        "routes": [
          {
            "path": "/datalab/:gamecode",
            "routes": [
              {
                "path": "/datalab/:gamecode/DataManagement/UserPackagesManagement",
                "component": require('@/pages/datalab/pages/Number/NumberPackage/index').default,
                "exact": true
              },
              {
                "path": "/datalab/:gamecode/WorkBench/MyAnalysis",
                "component": require('@/pages/datalab/pages/MyAnalyze/index').default,
                "exact": true
              },
              {
                "path": "/datalab/:gamecode/Analysis/MultiAnalysis",
                "component": require('@/pages/datalab/pages/Multidimensional/Analysis/index').default,
                "exact": true
              },
              {
                "path": "/datalab/:gamecode/Analysis/PacketExtraction",
                "component": require('@/pages/datalab/pages/Multidimensional/Extraction/index').default,
                "exact": true
              },
              {
                "path": "/datalab/:gamecode/DataManagement/SheetManagement",
                "component": require('@/pages/datalab/pages/Number/DataManagement/index').default,
                "exact": true
              },
              {
                "path": "/datalab/:gamecode/DataManagement/PersonalData",
                "component": require('@/pages/datalab/pages/Number/PersonalData/index').default,
                "exact": true
              },
              {
                "path": "/datalab/:gamecode/DataManagement/SheetManagement/Edit",
                "component": require('@/pages/datalab/pages/Number/DataManagement/TableEdit').default,
                "exact": true
              },
              {
                "path": "/datalab/:gamecode/DataManagement/SqlView",
                "component": require('@/pages/datalab/pages/Number/SqlView/index').default,
                "exact": true
              },
              {
                "path": "/datalab/:gamecode/DataManagement/ModelManagementCenter",
                "component": require('@/pages/datalab/pages/Number/ModelManagementCenter/index').default,
                "exact": true
              },
              {
                "path": "/datalab/:gamecode/DataManagement/ModelManagementCenter/Create",
                "component": require('@/pages/datalab/pages/Number/ModelAgentCreate/index').default,
                "exact": true
              },
              {
                "path": "/datalab/:gamecode/DataManagement/ModelManagementCenter/Edit",
                "component": require('@/pages/datalab/pages/Number/ModelAgentCreate/index').default,
                "exact": true
              },
              {
                "path": "/datalab/:gamecode/Action/ExploreAnalysis",
                "component": require('@/pages/datalab/pages/BehaviorAnalysis/ExplorationAnalysis/index').default,
                "exact": true
              },
              {
                "path": "/datalab/:gamecode/Action/GptAnalysis",
                "component": require('@/pages/datalab/pages/BehaviorAnalysis/GptAnalysis/index').default,
                "exact": true
              },
              {
                "path": "/datalab/:gamecode/Action/ABExperiment",
                "component": require('@/pages/datalab/pages/ABExperiment/index').default,
                "exact": true
              },
              {
                "path": "/datalab/:gamecode/WorkBench/MyDashboard",
                "component": require('@/pages/datalab/pages/WorkBench/MyDashboard/index').default,
                "exact": true
              },
              {
                "path": "/datalab/:gamecode/WorkBench/MyDashboard/ViewPage",
                "component": require('@/pages/datalab/pages/WorkBench/MyDashboard/viewPages').default,
                "exact": true
              },
              {
                "path": "/datalab/:gamecode/WorkBench/MyDashboard/CreateDashboard",
                "component": require('@/pages/datalab/pages/WorkBench/CreateReport/index').default,
                "exact": true
              },
              {
                "path": "/datalab/:gamecode/Home",
                "component": require('@/pages/datalab/pages/Home/index').default,
                "exact": true
              },
              {
                "path": "/datalab/:gamecode/Analysis/MultiAnalysis",
                "component": require('@/pages/datalab/pages/Multidimensional/Analysis/index').default,
                "exact": true
              },
              {
                "path": "/datalab/:gamecode/Analysis/ABTest",
                "component": require('@/pages/datalab/pages/ABExperiment/index').default,
                "exact": true
              }
            ]
          }
        ]
      },
      {
        "path": "/g-pop/DocPreviewer",
        "component": require('@/pages/globalpedia/pages/COSPreviewers').default,
        "exact": true
      },
      {
        "path": "/g-pop/VersionHistory",
        "component": require('@/pages/globalpedia/pages/VersionHistory').default,
        "exact": true
      },
      {
        "component": require('@/pages/globalpedia/layouts/index').default,
        "access": "layout",
        "path": "/g-pop",
        "routes": [
          {
            "path": "/g-pop/Pipeline/Overview",
            "component": require('@/pages/globalpedia/pages/Pipeline/Overview').default,
            "access": "pipeline_overview",
            "wrappers": [require('@/pages/globalpedia/components/Auth').default],
            "exact": true
          },
          {
            "path": "/g-pop/Pipeline/ProjectList",
            "component": require('@/pages/globalpedia/pages/Pipeline/Project').default,
            "access": "pipeline_project",
            "wrappers": [require('@/pages/globalpedia/components/Auth').default],
            "exact": true
          },
          {
            "path": "/g-pop/Pipeline/ProjectList/Detail",
            "component": require('@/pages/globalpedia/pages/Pipeline/ProjectDetails').default,
            "exact": true
          },
          {
            "path": "/g-pop/Pipeline/GRActionItems",
            "component": require('@/pages/globalpedia/pages/Pipeline/GRActionItems').default,
            "access": "pipeline_gr_action_items",
            "wrappers": [require('@/pages/globalpedia/components/Auth').default],
            "exact": true
          },
          {
            "path": "/g-pop/Pipeline/DPSNewsletter",
            "component": require('@/pages/globalpedia/pages/Pipeline/DPSReport').default,
            "access": "dps_weekly_report",
            "wrappers": [require('@/pages/globalpedia/components/Auth').default],
            "exact": true
          },
          {
            "path": "/g-pop/Pipeline/DPSNewsletter/AddReport",
            "component": require('@/pages/globalpedia/pages/Pipeline/DPSReport/AddReport.tsx').default,
            "access": "dps_weekly_report",
            "wrappers": [require('@/pages/globalpedia/components/Auth').default],
            "exact": true
          },
          {
            "path": "/g-pop/Pipeline/DPSNewsletter/EditReport",
            "component": require('@/pages/globalpedia/pages/Pipeline/DPSReport/EditReport.tsx').default,
            "access": "dps_weekly_report",
            "wrappers": [require('@/pages/globalpedia/components/Auth').default],
            "exact": true
          },
          {
            "path": "/g-pop/Pipeline/ChangeLog/:tab",
            "component": require('@/pages/globalpedia/pages/Pipeline/ChangeLog').default,
            "access": "pipeline_change_log",
            "wrappers": [require('@/pages/globalpedia/components/Auth').default],
            "exact": true
          },
          {
            "path": "/g-pop/Studio/PortfolioOverview",
            "component": require('@/pages/globalpedia/pages/StudioDashboard/StudioOverall').default,
            "exact": true
          },
          {
            "path": "/g-pop/Studio/PortfolioOverview/Detail",
            "component": require('@/pages/globalpedia/pages/StudioDashboard/StudioOverall/details').default,
            "exact": true
          },
          {
            "path": "/g-pop/Studio/MetricsDashboard",
            "component": require('@/pages/globalpedia/pages/StudioDashboard/StudioBusinessMetrics').default,
            "access": "studio_business_metrics",
            "wrappers": [require('@/pages/globalpedia/components/Auth').default],
            "exact": true
          },
          {
            "path": "/g-pop/MonthlyReport/PerformanceOverview",
            "component": require('@/pages/globalpedia/pages/StudioMonthlyReport/PerformanceOverview').default,
            "access": "performance_overview",
            "wrappers": [require('@/pages/globalpedia/components/Auth').default],
            "exact": true
          },
          {
            "path": "/g-pop/MonthlyReport/GrossRevenueTrends",
            "component": require('@/pages/globalpedia/pages/StudioMonthlyReport/GrossRevenueTrends').default,
            "access": "gross_revenue_trends",
            "wrappers": [require('@/pages/globalpedia/components/Auth').default],
            "exact": true
          },
          {
            "path": "/g-pop/MonthlyReport/LiveTitle",
            "component": require('@/pages/globalpedia/pages/StudioMonthlyReport/LiveTitle').default,
            "access": "live_title",
            "wrappers": [require('@/pages/globalpedia/components/Auth').default],
            "exact": true
          },
          {
            "path": "/g-pop/MonthlyReport/InDevTitle",
            "component": require('@/pages/globalpedia/pages/StudioMonthlyReport/InDevelopment').default,
            "access": "in_development",
            "wrappers": [require('@/pages/globalpedia/components/Auth').default],
            "exact": true
          },
          {
            "path": "/g-pop/Metrics",
            "component": require('@/pages/globalpedia/pages/Metrics').default,
            "access": "metrics",
            "wrappers": [require('@/pages/globalpedia/components/Auth').default],
            "exact": true
          },
          {
            "path": "/g-pop/Workspace/AddProduct",
            "component": require('@/pages/globalpedia/pages/Workspace/Product').default,
            "access": "add_new_product",
            "wrappers": [require('@/pages/globalpedia/components/Auth').default],
            "exact": true
          },
          {
            "path": "/",
            "component": require('@/pages/globalpedia/pages/index').default,
            "exact": true
          },
          {
            "path": "/g-pop/Workspace/DPSReport",
            "redirect": "/g-pop/Pipeline/DPSNewsletter",
            "exact": true
          },
          {
            "path": "/g-pop/Workspace/DPSReport/AddReport",
            "redirect": "/g-pop/Pipeline/DPSNewsletter/AddReport",
            "exact": true
          },
          {
            "path": "/g-pop/Workspace/DPSReport/EditReport",
            "redirect": "/g-pop/Pipeline/DPSNewsletter/EditReport",
            "exact": true
          },
          {
            "path": "/g-pop/Pipeline/ChangeLog",
            "redirect": "/g-pop/Pipeline/ChangeLog/ChangeDetail",
            "exact": true
          },
          {
            "path": "/g-pop",
            "component": require('@/pages/globalpedia/pages/index').default,
            "exact": true
          },
          {
            "component": require('@/pages/globalpedia/pages/NotFoundPage').default,
            "exact": true
          }
        ]
      },
      {
        "path": "/opinion",
        "component": require('@/pages/opinion/layouts/index').default,
        "routes": [
          {
            "path": "/opinion/AITaskCenter",
            "routes": [
              {
                "path": "/opinion/AITaskCenter",
                "component": require('@/pages/opinion/pages/AITaskCenter/index').default,
                "exact": true
              },
              {
                "path": "/opinion/AITaskCenter/Unsubscribe",
                "component": require('@/pages/opinion/pages/AITaskCenter/Unsubscribe/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/opinion/download",
            "component": require('@/pages/opinion/components/DownloadCommon/download-page/index').default,
            "exact": true
          },
          {
            "path": "/opinion/TrendingPublications",
            "component": require('@/pages/opinion/pages/Overview/TrendingPublications/index').default,
            "exact": true
          },
          {
            "path": "/opinion/MonitorScope",
            "component": require('@/pages/opinion/pages/MonitorScope/index').default,
            "exact": true
          },
          {
            "path": "/opinion/NewDownload",
            "component": require('@/pages/opinion/pages/download/index').default,
            "exact": true
          },
          {
            "path": "/opinion/Overview",
            "routes": [
              {
                "path": "/opinion/Overview",
                "component": require('@/pages/opinion/pages/Performance/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Overview/KeyOpinions",
                "component": require('@/pages/opinion/pages/Overview/KeyOpinions/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Overview/KeyMetrics",
                "component": require('@/pages/opinion/pages/Overview/KeyMetrics/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Overview/KeyMetrics/EventDetails",
                "component": require('@/pages/opinion/pages/Overview/KeyMetrics/EventDetails/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Overview/CompareKeyMetrics",
                "component": require('@/pages/opinion/pages/Overview/CompareKeyMetrics/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Overview/TrendingPublications",
                "component": require('@/pages/opinion/pages/Overview/TrendingPublications/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Overview/Nikke",
                "component": require('@/pages/opinion/pages/NIKKE').default,
                "exact": true
              },
              {
                "path": "/opinion/Overview/MarketPopularityRanking",
                "component": require('@/pages/opinion/pages/Compare/ChannelShareRanking/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Overview/RealtimeOpinions",
                "component": require('@/pages/opinion/pages/Overview/RealtimeOpinions/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/opinion/Summary",
            "routes": [
              {
                "path": "/opinion/Summary/HotEvent",
                "component": require('@/pages/opinion/pages/Summary/SummaryHotEvent').default,
                "exact": true
              },
              {
                "path": "/opinion/Summary/TopicTracking",
                "component": require('@/pages/opinion/pages/Summary/TopicTracking').default,
                "exact": true
              },
              {
                "path": "/opinion/Summary/Excel",
                "component": require('@/pages/opinion/pages/Summary/TopicTrackingExcel').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/opinion/EventDetails",
            "component": require('@/pages/opinion/pages/EventDetails/index').default,
            "exact": true
          },
          {
            "path": "/opinion/AIAnalysisHub",
            "routes": [
              {
                "path": "/opinion/AIAnalysisHub/CustomAISummary",
                "component": require('@/pages/opinion/pages/AIAnalysisHub/CustomAISummary/index').default,
                "exact": true
              },
              {
                "path": "/opinion/AIAnalysisHub/CustomAISummary/preview/:id",
                "component": require('@/pages/opinion/pages/AIAnalysisHub/CustomAISummary/pages/PreviewSummary/index').default,
                "exact": true
              },
              {
                "path": "/opinion/AIAnalysisHub/KeywordAnalysis/preview/:id",
                "component": require('@/pages/opinion/pages/AIAnalysisHub/KeywordAndURLAnalysis/PreviewAnalysis').default,
                "exact": true
              },
              {
                "path": "/opinion/AIAnalysisHub/URLAnalysis/preview/:id",
                "component": require('@/pages/opinion/pages/AIAnalysisHub/KeywordAndURLAnalysis/PreviewAnalysis').default,
                "exact": true
              },
              {
                "path": "/opinion/AIAnalysisHub/KeywordAnalysis",
                "component": require('@/pages/opinion/pages/AIAnalysisHub/KeywordAndURLAnalysis/KeywordAnalysis').default,
                "exact": true
              },
              {
                "path": "/opinion/AIAnalysisHub/AITopicAnalysis",
                "component": require('@/pages/opinion/pages/AIAnalysisHub/KeywordAndURLAnalysis/AITopicAnalysis').default,
                "exact": true
              },
              {
                "path": "/opinion/AIAnalysisHub/URLAnalysis",
                "component": require('@/pages/opinion/pages/AIAnalysisHub/KeywordAndURLAnalysis/URLAnalysis').default,
                "exact": true
              },
              {
                "path": "/opinion/AIAnalysisHub/AIInsightsReport",
                "component": require('@/pages/opinion/pages/AIAnalysisHub/AIInsightsReport').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/opinion/News",
            "component": require('@/pages/opinion/pages/news/index').default,
            "exact": true
          },
          {
            "path": "/opinion/Stats",
            "routes": [
              {
                "path": "/opinion/Stats/Detail",
                "component": require('@/pages/opinion/pages/stats/Detail/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Stats/KeywordCorrelation",
                "component": require('@/pages/opinion/pages/keywordCorrelation/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Stats/Channel",
                "component": require('@/pages/opinion/pages/stats/channel/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Stats/Version",
                "component": require('@/pages/opinion/pages/stats/version/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Stats/Language",
                "component": require('@/pages/opinion/pages/stats/language/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Stats/Region",
                "component": require('@/pages/opinion/pages/stats/regionCountry/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Stats/Topic",
                "component": require('@/pages/opinion/pages/stats/topic/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Stats/Keyword",
                "component": require('@/pages/opinion/pages/stats/keyword/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/opinion/Feeds/Feeds",
            "component": require('@/pages/opinion/pages/feeds/index').default,
            "exact": true
          },
          {
            "path": "/opinion/Feeds/Feeds/Details/:id",
            "component": require('@/pages/opinion/pages/feeds/Details/index').default,
            "exact": true
          },
          {
            "path": "/opinion/trends",
            "component": require('@/pages/opinion/pages/trends/index').default,
            "exact": true
          },
          {
            "path": "/opinion/Community",
            "routes": [
              {
                "path": "/opinion/Community/Streaming",
                "component": require('@/pages/opinion/pages/community/streaming').default,
                "exact": true
              },
              {
                "path": "/opinion/Community/Video",
                "component": require('@/pages/opinion/pages/community/video/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Community/Hashtag",
                "component": require('@/pages/opinion/pages/community/hashtag/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/opinion/Influencer",
            "routes": [
              {
                "path": "/opinion/Influencer/BrandOverview",
                "component": require('@/pages/opinion/pages/Influencer/BrandOverview/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Influencer/BrandCreatorList",
                "component": require('@/pages/opinion/pages/Influencer/BrandCreatorList/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Influencer/GenreCreatorList",
                "component": require('@/pages/opinion/pages/Influencer/GenreCreatorList/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/opinion/Accounts",
            "routes": [
              {
                "path": "/opinion/Accounts/ByChannel/:tab?",
                "component": require('@/pages/opinion/pages/accounts/bychannel/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Accounts/ByAccount/:tab?",
                "component": require('@/pages/opinion/pages/accounts/byaccount/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/opinion/DataMap",
            "routes": [
              {
                "path": "/opinion/DataMap/OpinionsSources",
                "component": require('@/pages/opinion/pages/dataMap/opinionsSources/index').default,
                "exact": true
              },
              {
                "path": "/opinion/DataMap/OpinionsMetrics",
                "component": require('@/pages/opinion/pages/dataMap/opinionsMetrics/index').default,
                "exact": true
              },
              {
                "path": "/opinion/DataMap/NewsCrawlers",
                "component": require('@/pages/opinion/pages/dataMap/newsCrawlers/index').default,
                "exact": true
              },
              {
                "path": "/opinion/DataMap/SentimentCriteria",
                "component": require('@/pages/opinion/pages/dataMap/sentimentCriteria/index').default,
                "exact": true
              },
              {
                "path": "/opinion/DataMap/ValidationCriteria",
                "component": require('@/pages/opinion/pages/dataMap/validationCriteria/index').default,
                "exact": true
              },
              {
                "path": "/opinion/DataMap/AISummaryDemo",
                "component": require('@/pages/opinion/pages/dataMap/GPTSummaryDemo/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/opinion/GameStore",
            "component": require('@/pages/opinion/pages/gamestore/index').default,
            "exact": true
          },
          {
            "path": "/opinion/SteamPerformance",
            "routes": [
              {
                "path": "/opinion/SteamPerformance",
                "component": require('@/pages/opinion/pages/SteamPerformance/SteamRatings/index').default,
                "exact": true
              },
              {
                "path": "/opinion/SteamPerformance/SteamRatings",
                "component": require('@/pages/opinion/pages/SteamPerformance/SteamRatings/index').default,
                "exact": true
              },
              {
                "path": "/opinion/SteamPerformance/RealtimeRatings",
                "component": require('@/pages/opinion/pages/SteamPerformance/RealtimeRatings/index').default,
                "exact": true
              },
              {
                "path": "/opinion/SteamPerformance/Insights",
                "component": require('@/pages/opinion/pages/SteamPerformance/Insights/index').default,
                "exact": true
              },
              {
                "path": "/opinion/SteamPerformance/VersionAnalysis",
                "component": require('@/pages/opinion/pages/SteamPerformance/VersionAnalysis/List/index').default,
                "exact": true
              },
              {
                "path": "/opinion/SteamPerformance/VersionAnalysis/Details",
                "component": require('@/pages/opinion/pages/SteamPerformance/VersionAnalysis/Details/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/opinion/Competitor",
            "component": require('@/pages/opinion/pages/competitor/index').default,
            "exact": true
          },
          {
            "path": "/opinion/Compare",
            "routes": [
              {
                "path": "/opinion/Compare",
                "component": require('@/pages/opinion/pages/Compare/Compare/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Compare/Compare",
                "component": require('@/pages/opinion/pages/Compare/Compare/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/opinion/Detail",
            "component": require('@/pages/opinion/pages/Detail').default,
            "exact": true
          },
          {
            "path": "/opinion/authPath/report/:reportId",
            "component": require('@/pages/opinion/pages/authPath/index').default,
            "exact": true
          },
          {
            "path": "/opinion/Report/VoiceReportingTextAnalysis",
            "component": require('@/pages/opinion/pages/report/VoiceReportingTextAnalysis').default,
            "exact": true
          },
          {
            "path": "/opinion/Report/:reportId",
            "component": require('@/pages/opinion/pages/report/report').default,
            "exact": true
          },
          {
            "path": "/opinion/Looker/:lookerId",
            "component": require('@/pages/opinion/pages/report/looker').default,
            "exact": true
          },
          {
            "path": "/opinion/Insights",
            "component": require('@/pages/opinion/pages/report/insight').default,
            "exact": true
          },
          {
            "path": "/opinion/gpt/GPT Auto Report",
            "component": require('@/pages/opinion/pages/report/gpt').default,
            "exact": true
          },
          {
            "path": "/opinion/gptReport/:menuId/:kind/:hasReportId",
            "component": require('@/pages/opinion/pages/report/gptReport').default,
            "exact": true
          },
          {
            "path": "/opinion/Preset/:reportId",
            "component": require('@/pages/opinion/pages/report/preset').default,
            "exact": true
          },
          {
            "path": "/opinion/PDFReport/:pdfId",
            "component": require('@/pages/opinion/pages/report/pdfReport').default,
            "exact": true
          },
          {
            "path": "/opinion/AIGalleryReport/:reportId",
            "component": require('@/pages/opinion/pages/report/AIGalleryReport').default,
            "exact": true
          },
          {
            "path": "/opinion/Hero",
            "component": require('@/pages/opinion/pages/Hero').default,
            "exact": true
          },
          {
            "path": "/opinion/CustomizeReport/:name/:id",
            "component": require('@/pages/opinion/pages/report/CustomizeReport').default,
            "exact": true
          },
          {
            "path": "/opinion/Realtime",
            "routes": [
              {
                "path": "/opinion/Realtime/RealtimeStreaming",
                "component": require('@/pages/opinion/pages/RealtimeStreaming/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Realtime/RealtimeStreaming/Details/:id",
                "component": require('@/pages/opinion/pages/RealtimeStreaming/Details/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/opinion/Security-RelatedMentionsWeeklyReport",
            "component": require('@/pages/opinion/pages/SecurityWeeklyReport/index').default,
            "exact": true
          },
          {
            "path": "/opinion/AdDeliveryOverview",
            "routes": [
              {
                "path": "/opinion/AdDeliveryOverview",
                "component": require('@/pages/opinion/pages/adCreatives/overview/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/opinion/CustomizedReports",
            "routes": [
              {
                "path": "/opinion/CustomizedReports/WeeklyReport",
                "routes": [
                  {
                    "path": "/opinion/CustomizedReports/WeeklyReport/Overview",
                    "component": require('@/pages/opinion/pages/CustomizedReports/WeeklyReport/Overview').default,
                    "exact": true
                  },
                  {
                    "path": "/opinion/CustomizedReports/WeeklyReport/OfficialAccountsPerformance",
                    "component": require('@/pages/opinion/pages/CustomizedReports/WeeklyReport/OfficialAccountsPerformance').default,
                    "exact": true
                  },
                  {
                    "path": "/opinion/CustomizedReports/WeeklyReport/VersionPerformance",
                    "component": require('@/pages/opinion/pages/CustomizedReports/WeeklyReport/VersionPerformance').default,
                    "exact": true
                  },
                  {
                    "path": "/opinion/CustomizedReports/WeeklyReport/VersionPerformance/Configuration",
                    "component": require('@/pages/opinion/pages/CustomizedReports/WeeklyReport/Configuration').default,
                    "exact": true
                  }
                ]
              }
            ]
          },
          {
            "path": "/opinion/",
            "component": require('@/pages/opinion/pages/Overview/KeyMetrics/index').default,
            "exact": true
          },
          {
            "path": "/opinion/gamelist",
            "component": require('@/pages/opinion/pages/gamelist/index').default,
            "exact": true
          },
          {
            "path": "/opinion/",
            "routes": [
              {
                "path": "/opinion/noPermission",
                "component": require('@/pages/opinion/pages/noPermission/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Demo/Filter/DFFDDFFDFDFDFDDFDFDF",
                "component": require('@/pages/opinion/pages/Demo/Filter').default,
                "exact": true
              },
              {
                "path": "/opinion/Demo/GPTPage",
                "component": require('@/pages/opinion/pages/Demo/GPT').default,
                "exact": true
              },
              {
                "path": "/opinion/Demo/Format",
                "component": require('@/pages/opinion/pages/Demo/Format').default,
                "exact": true
              },
              {
                "path": "/opinion/Lock/:id",
                "component": require('@/pages/opinion/pages/Lock/index').default,
                "exact": true
              },
              {
                "path": "/opinion/Demo/EChart",
                "component": require('@/pages/opinion/pages/Demo/EChart').default,
                "exact": true
              }
            ]
          }
        ]
      },
      {
        "path": "/marketing",
        "component": require('@/pages/marketing/layouts/index').default,
        "routes": [
          {
            "path": "/marketing/Videos",
            "component": require('@/pages/marketing/pages/Videos/index').default,
            "exact": true
          },
          {
            "path": "/marketing/Hashtag",
            "component": require('@/pages/marketing/pages/Hashtag/index').default,
            "exact": true
          },
          {
            "path": "/marketing/Hashtag/Details",
            "component": require('@/pages/marketing/pages/Hashtag/Details/index').default,
            "exact": true
          },
          {
            "path": "/marketing/Memes",
            "component": require('@/pages/marketing/pages/Memes/index').default,
            "exact": true
          },
          {
            "path": "/marketing/Memes/Details",
            "component": require('@/pages/marketing/pages/Memes/Details/index').default,
            "exact": true
          },
          {
            "path": "/marketing/Download",
            "component": require('@/pages/marketing/pages/Download/index').default,
            "exact": true
          },
          {
            "path": "/marketing/CompetitorsAdCreatives",
            "component": require('@/pages/marketing/pages/CompetitorsAdCreatives/index').default,
            "exact": true
          },
          {
            "path": "/marketing/CompetitorAdComparison",
            "component": require('@/pages/marketing/pages/CompetitorAdComparison/index').default,
            "exact": true
          },
          {
            "path": "/marketing/CreativeTrends",
            "component": require('@/pages/marketing/pages/CreativeTrends/index').default,
            "exact": true
          },
          {
            "path": "/marketing/CreativeTrends/Details",
            "component": require('@/pages/marketing/pages/CreativeTrends/Details/index').default,
            "exact": true
          },
          {
            "path": "/marketing/UgcCreativeTrends",
            "component": require('@/pages/marketing/pages/UgcCreativeTrends/index').default,
            "exact": true
          },
          {
            "path": "/marketing/UgcCreativeTrends/Details",
            "component": require('@/pages/marketing/pages/UgcCreativeTrends/Details/index').default,
            "exact": true
          },
          {
            "path": "/marketing/MahjongSolitaire/TopCreatives",
            "component": require('@/pages/marketing/pages/ZoneTopCreatives/index').default,
            "exact": true
          },
          {
            "path": "/marketing/Arrows/TopCreatives",
            "component": require('@/pages/marketing/pages/ZoneTopCreatives/index').default,
            "exact": true
          },
          {
            "path": "/marketing/MahjongSolitaire/TrendingPublications",
            "component": require('@/pages/marketing/pages/ZoneTrendingPublications/index').default,
            "exact": true
          },
          {
            "path": "/marketing/Arrows/TrendingPublications",
            "component": require('@/pages/marketing/pages/ZoneTrendingPublications/index').default,
            "exact": true
          },
          {
            "path": "/marketing/Merge2/TopCreatives",
            "component": require('@/pages/marketing/pages/ZoneTopCreatives/index').default,
            "exact": true
          },
          {
            "path": "/marketing/Merge2/TrendingPublications",
            "component": require('@/pages/marketing/pages/ZoneTrendingPublications/index').default,
            "exact": true
          },
          {
            "path": "/marketing/Merge3/TopCreatives",
            "component": require('@/pages/marketing/pages/ZoneTopCreatives/index').default,
            "exact": true
          },
          {
            "path": "/marketing/Merge3/TrendingPublications",
            "component": require('@/pages/marketing/pages/ZoneTrendingPublications/index').default,
            "exact": true
          }
        ]
      },
      {
        "path": "/intelligence/componentDocs",
        "component": require('@/pages/intelligence/v3/componentDocs/index').default,
        "exact": true
      },
      {
        "path": "/intelligence/filterable-page-demo",
        "component": require('@/pages/intelligence/v3/pages/FilterablePageDemo/index').default,
        "exact": true
      },
      {
        "path": "/intelligence/filterable-page-demo/detail",
        "component": require('@/pages/intelligence/v3/pages/FilterablePageDemo/Detail').default,
        "exact": true
      },
      {
        "path": "/intelligence/download",
        "component": require('@/pages/intelligence/pages/Download/index').default,
        "exact": true
      },
      {
        "path": "/intelligence/pdfPreviewDownload",
        "component": require('@/pages/intelligence/pages/PDFPreviewDownload/index').default,
        "exact": true
      },
      {
        "path": "/intelligence/downloadCommon",
        "component": require('@/pages/intelligence/components/DownloadCommon/DownloadPage/index').default,
        "exact": true
      },
      {
        "path": "/intelligence/pdfPreviewDownloadLikeShare",
        "component": require('@/pages/intelligence/pages/PDFPreviewDownloadLikeShare/index').default,
        "exact": true
      },
      {
        "path": "/intelligence/reportDetails/:systemId/:resourceId",
        "component": require('@/pages/intelligence/v3/pages/ReportDetailsMiddlePage/index').default,
        "exact": true
      },
      {
        "path": "/intelligence",
        "component": require('@/pages/intelligence/layouts/index').default,
        "routes": [
          {
            "path": "/intelligence/authPath/report/:reportId",
            "component": require('@/pages/intelligence/pages/authPath/index').default,
            "exact": true
          },
          {
            "path": "/intelligence/ipCollaboration",
            "component": require('@/pages/intelligence/pages/IpCollaboration/index').default,
            "exact": true
          },
          {
            "path": "/intelligence/marketProfile",
            "routes": [
              {
                "path": "/intelligence/marketProfile/:tab?",
                "component": require('@/pages/intelligence/pages/MarketProfile/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/marketProfile/:tab?/detail",
                "component": require('@/pages/intelligence/pages/MarketProfile/TabDetails/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/intelligence/mobileDevice",
            "component": require('@/pages/intelligence/pages/MobileDevice/Stats/index').default,
            "exact": true
          },
          {
            "path": "/intelligence/casualDailyReports",
            "component": require('@/pages/intelligence/v3/pages/CasualDailyReports/index').default,
            "exact": true
          },
          {
            "path": "/intelligence/aiDailyNews/globalGamingDynamics",
            "component": require('@/pages/intelligence/v3/pages/CasualWordlWide/index').default,
            "exact": true
          },
          {
            "path": "/intelligence/topCharts",
            "routes": [
              {
                "path": "/intelligence/topCharts/mobileGames/:tab?",
                "component": require('@/pages/intelligence/v3/pages/TopCharts/MobileGames').default,
                "exact": true
              },
              {
                "path": "/intelligence/topCharts/mobileGames/gamesDetails/:id/:tab?/:segment?",
                "component": require('@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/topCharts/companies/:tab?",
                "component": require('@/pages/intelligence/pages/TopCharts/Companies/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/topCharts/companies/gamesDetails/:id/:tab/:segment?",
                "component": require('@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/topCharts/pcGames/:tab?",
                "component": require('@/pages/intelligence/pages/TopCharts/PCGames/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/topCharts/pcGames/gamesDetails/:id/:tab?/:segment?",
                "component": require('@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/topCharts/consoleGames/:tab?",
                "component": require('@/pages/intelligence/pages/TopCharts/ConsoleGames/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/topCharts/consoleGames/gamesDetails/:id/:tab?/:segment?",
                "component": require('@/pages/intelligence/pages/TopCharts/ConsoleGames/components/GamesDetails/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/topCharts/pcConsoleGames/:tab?",
                "component": require('@/pages/intelligence/pages/TopCharts/PCConsoleGames/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/topCharts/pcConsoleGames/gamesDetails/:id/:tab?/:segment?",
                "component": require('@/pages/intelligence/pages/TopCharts/PCConsoleGames/components/GamesDetails/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/topCharts/eventDetails",
                "component": require('@/pages/intelligence/v3/pages/OpinionEventDetails/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/intelligence/potential",
            "routes": [
              {
                "path": "/intelligence/potential/newReleaseGames/:tab?",
                "component": require('@/pages/intelligence/pages/Potential/NewReleaseGames/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/potential/upcomingGames/:tab?",
                "component": require('@/pages/intelligence/pages/Potential/UpcomingGames/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/potential/steamMetrics",
                "component": require('@/pages/intelligence/pages/Potential/SteamMetrics/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/intelligence/sourcesMetrics",
            "routes": [
              {
                "path": "/intelligence/sourcesMetrics/overview",
                "component": require('@/pages/intelligence/pages/SourcesMetrics/Overview/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/sourcesMetrics/Sources/:tab?",
                "component": require('@/pages/intelligence/pages/SourcesMetrics/Sources/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/sourcesMetrics/Metrics/:tab?",
                "component": require('@/pages/intelligence/pages/SourcesMetrics/Metrics/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/intelligence/storeRanks",
            "routes": [
              {
                "path": "/intelligence/storeRanks/MobileGlobalRegion/:tab?",
                "component": require('@/pages/intelligence/pages/StoreRanks/MobileGlobalRegion/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/storeRanks/MobileGlobalRegion/more/:tab?",
                "component": require('@/pages/intelligence/pages/StoreRanks/MobileGlobalRegion/page/more/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/storeRanks/PCGlobal/:tab?",
                "component": require('@/pages/intelligence/pages/StoreRanks/PCGlobal/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/storeRanks/PCGlobal/more/:tab?",
                "component": require('@/pages/intelligence/pages/StoreRanks/PCGlobal/page/more/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/storeRanks/ConsoleRegion/:tab?",
                "component": require('@/pages/intelligence/pages/StoreRanks/ConsoleRegion/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/storeRanks/ConsoleRegion/more/:tab?",
                "component": require('@/pages/intelligence/pages/StoreRanks/ConsoleRegion/page/more/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/intelligence/streaming",
            "routes": [
              {
                "path": "/intelligence/streaming/influencer",
                "component": require('@/pages/intelligence/pages/Streaming/Kol/page/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/streaming/influencer/details/:tab?",
                "component": require('@/pages/intelligence/pages/Streaming/Kol/details/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/streaming/games",
                "component": require('@/pages/intelligence/pages/Streaming/Games/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/intelligence/genreProfile",
            "routes": [
              {
                "path": "/intelligence/genreProfile/:tab?",
                "component": require('@/pages/intelligence/pages/GenreProfile/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/genreProfile/:tab?/detail/:tab",
                "component": require('@/pages/intelligence/pages/GenreProfile/Detailspage/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/intelligence/following",
            "routes": [
              {
                "path": "/intelligence/following/manage/:tab?",
                "component": require('@/pages/intelligence/pages/Following/Manage/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/following/:tab?",
                "component": require('@/pages/intelligence/pages/Following/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/intelligence/reports",
            "routes": [
              {
                "path": "/intelligence/reports/reportSearch",
                "component": require('@/pages/intelligence/pages/ReportSearch/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/reports/aiHubReports",
                "component": require('@/pages/intelligence/pages/AIHubReports/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/reports/trendingGames/:uid?/:ver?",
                "component": require('@/pages/intelligence/pages/TrendingGames/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/reports/marketReports",
                "component": require('@/pages/intelligence/pages/BusinessReports/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/reports/insightsReports",
                "component": require('@/pages/intelligence/pages/InsightsReport/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/reports/insightsCenterLibrary",
                "component": require('@/pages/intelligence/pages/InsightsCenterLibrary/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/reports/iMurReports",
                "component": require('@/pages/intelligence/pages/iMurReports/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/reports/socDiscountReport",
                "component": require('@/pages/intelligence/v3/pages/LowCodeTemplateWrapper').default,
                "exact": true
              },
              {
                "path": "/intelligence/reports/gameAnalysis",
                "component": require('@/pages/intelligence/pages/GameAnalysis/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/intelligence/compare",
            "routes": [
              {
                "path": "/intelligence/compare/mobileGames/:tab?",
                "component": require('@/pages/intelligence/pages/Compare/MobileGames/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/compare/PcConsoleGamesBeta/:tab?",
                "component": require('@/pages/intelligence/pages/Compare/PcConsoleGamesBeta/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/compare/pcConsoleGames/:tab?",
                "component": require('@/pages/intelligence/pages/Compare/PcConsoleGames/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/intelligence/globalView",
            "routes": [
              {
                "path": "/intelligence/globalView/marketSize/:tab?",
                "component": require('@/pages/intelligence/pages/GlobalView/MarketSize/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/globalView/TopGenreperMarket",
                "component": require('@/pages/intelligence/pages/GlobalView/TopGenrePerMarket/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/globalView/TopMarketperGenre",
                "component": require('@/pages/intelligence/pages/GlobalView/TopMarketPerGenre/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/intelligence/metricsCreditability",
            "component": require('@/pages/intelligence/pages/MetricsCreditability').default,
            "exact": true
          },
          {
            "path": "/intelligence/IPLibrary/:tab",
            "component": require('@/pages/intelligence/v3/components/DatalabReport').default,
            "exact": true
          },
          {
            "path": "/intelligence/benchmark",
            "routes": [
              {
                "path": "/intelligence/benchmark/mobileGameBenchmark",
                "component": require('@/pages/intelligence/pages/MobileGameBenchmark/index').default,
                "exact": true
              },
              {
                "path": "/intelligence/benchmark/pcConsoleBenchmark",
                "component": require('@/pages/intelligence/pages/PCConsoleBenchmark/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/intelligence/overlapAnalysis",
            "routes": [
              {
                "path": "/intelligence/overlapAnalysis/MobileGames",
                "component": require('@/pages/intelligence/pages/OverlapAnalysis/MobileGames').default,
                "exact": true
              },
              {
                "path": "/intelligence/overlapAnalysis/steamGames",
                "component": require('@/pages/intelligence/pages/OverlapAnalysis/SteamGames').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/intelligence/gameResearchReport",
            "component": require('@/pages/intelligence/pages/GameResearchReport/index').default,
            "exact": true
          },
          {
            "path": "/intelligence/aiDailyNews/:templateName",
            "component": require('@/pages/intelligence/v3/pages/LowCodeTemplateWrapper').default,
            "exact": true
          },
          {
            "path": "/intelligence/casualGamesHub",
            "routes": [
              {
                "path": "/intelligence/casualGamesHub/casualGamesOverview",
                "component": require('@/pages/intelligence/v3/pages/CasualHubCompetitorsBridge').default,
                "exact": true
              },
              {
                "path": "/intelligence/casualGamesHub/keyGames",
                "component": require('@/pages/intelligence/v3/pages/ReusePages/KeyGames').default,
                "exact": true
              },
              {
                "path": "/intelligence/casualGamesHub/arrowsTopCharts",
                "component": require('@/pages/intelligence/v3/pages/ReusePages/ArrowsTopCharts').default,
                "exact": true
              },
              {
                "path": "/intelligence/casualGamesHub/casualTopChartsAM/:tab?",
                "component": require('@/pages/intelligence/v3/pages/ReusePages/CasualTopChartsAM').default,
                "exact": true
              },
              {
                "path": "/intelligence/casualGamesHub/casualTopChartsST/:tab?",
                "component": require('@/pages/intelligence/v3/pages/ReusePages/CasualTopChartsST').default,
                "exact": true
              },
              {
                "path": "/intelligence/casualGamesHub/casualTopChartsMahjong/:tab?",
                "component": require('@/pages/intelligence/v3/pages/ReusePages/CasualTopChartsMahjong').default,
                "exact": true
              },
              {
                "path": "/intelligence/casualGamesHub/narrativeMerge2TopCharts",
                "component": require('@/pages/intelligence/v3/pages/ReusePages/NarrativeMerge2TopCharts').default,
                "exact": true
              },
              {
                "path": "/intelligence/casualGamesHub/casualGamesStoreRanks/:tab?",
                "component": require('@/pages/intelligence/v3/pages/ReusePages/CasualGamesStoreRanks').default,
                "exact": true
              },
              {
                "path": "/intelligence/casualGamesHub/casualMiniGameRankings/gamesDetails/:id",
                "component": require('@/pages/intelligence/v3/pages/MiniGameDetails').default,
                "exact": true
              },
              {
                "path": "/intelligence/casualGamesHub/casualMiniGameRankings/more/:tab?",
                "component": require('@/pages/intelligence/v3/pages/ReusePages/CasualMiniGameRankings/components/More').default,
                "exact": true
              },
              {
                "path": "/intelligence/casualGamesHub/casualMiniGameRankings/:tab?",
                "component": require('@/pages/intelligence/v3/pages/ReusePages/CasualMiniGameRankings').default,
                "exact": true
              },
              {
                "path": "/intelligence/casualGamesHub/robloxGameRank",
                "component": require('@/pages/intelligence/v3/pages/RobloxGameRank').default,
                "exact": true
              },
              {
                "path": "/intelligence/casualGamesHub/robloxTopCharts",
                "component": require('@/pages/intelligence/v3/pages/RobloxTopCharts').default,
                "exact": true
              },
              {
                "path": "/intelligence/casualGamesHub/gamesOverlap",
                "component": require('@/pages/intelligence/v3/pages/ReusePages/GamesOverlap').default,
                "exact": true
              },
              {
                "path": "/intelligence/casualGamesHub/genreAnalysis",
                "component": require('@/pages/intelligence/v3/components/DatalabReport').default,
                "exact": true
              },
              {
                "path": "/intelligence/casualGamesHub/casualGenreProfile",
                "component": require('@/pages/intelligence/v3/pages/CasualGenreProfile').default,
                "exact": true
              },
              {
                "path": "/intelligence/casualGamesHub/reports",
                "routes": [
                  {
                    "path": "/intelligence/casualGamesHub/reports/",
                    "redirect": "/intelligence/casualGamesHub/reports/marketReports",
                    "exact": true
                  },
                  {
                    "path": "/intelligence/casualGamesHub/reports/marketReports",
                    "component": require('@/pages/intelligence/v3/pages/ReusePages/CasualGamesReports').default,
                    "exact": true
                  },
                  {
                    "path": "/intelligence/casualGamesHub/reports/analysisReports",
                    "component": require('@/pages/intelligence/v3/pages/ReusePages/CasualGamesReports').default,
                    "exact": true
                  }
                ]
              },
              {
                "path": "/intelligence/casualGamesHub/IAABenchmarks",
                "component": require('@/pages/intelligence/v3/pages/LowCodeTemplateWrapper').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/intelligence/*",
            "component": require('@/pages/home/pages/NotFound/index').default,
            "exact": true
          }
        ]
      },
      {
        "path": "/aigc",
        "exact": true,
        "redirect": "/aigc/AITools"
      },
      {
        "path": "/aigc2",
        "exact": true,
        "redirect": "/aigc/Action/GptAnalysis"
      },
      {
        "path": "/aigc/Action/GptAnalysis",
        "exact": true,
        "redirect": "/aigc2/Action/GptAnalysis"
      },
      {
        "path": "/aigc2/AITools",
        "exact": true,
        "redirect": "/aigc/AITools"
      },
      {
        "path": "/agent",
        "exact": true,
        "redirect": "/agent/home"
      },
      {
        "path": "/aigc",
        "component": require('@/pages/aigc/layouts/index').default,
        "routes": [
          {
            "path": "/aigc/Analysis",
            "component": require('@/pages/aigc/pages/DataAnalysis/index').default,
            "exact": true
          },
          {
            "path": "/aigc/Action/GptAnalysis",
            "component": require('@/pages/datalab/pages/BehaviorAnalysis/GptAnalysis/index').default,
            "exact": true
          },
          {
            "path": "/aigc/AITools",
            "component": require('@/pages/aigc/pages/Tools/index').default,
            "exact": true
          },
          {
            "path": "/aigc/ResourceUpload",
            "component": require('@/pages/aigc/pages/ResourceUpload/index').default,
            "exact": true
          },
          {
            "path": "/aigc/report-summary",
            "component": require('@/pages/aigc/pages/reportSummary/index').default,
            "exact": true
          },
          {
            "path": "/aigc/Text2SQL",
            "component": require('@/pages/aigc/pages/Text2SQL/index').default,
            "exact": true
          },
          {
            "path": "/aigc/GPTTranslator",
            "component": require('@/pages/aigc/pages/GPTTranslator/index').default,
            "exact": true
          },
          {
            "path": "/aigc/motion-capture",
            "component": require('@/pages/aigc/pages/MotionCapture/index').default,
            "exact": true
          }
        ]
      },
      {
        "path": "/aigc2",
        "component": require('@/pages/aigc/layouts/index').default,
        "routes": [
          {
            "path": "/aigc2/Analysis",
            "component": require('@/pages/aigc/pages/DataAnalysis/index').default,
            "exact": true
          },
          {
            "path": "/aigc2/Action/GptAnalysis",
            "component": require('@/pages/datalab/pages/BehaviorAnalysis/GptAnalysis/index').default,
            "exact": true
          },
          {
            "path": "/aigc2/AITools",
            "component": require('@/pages/aigc/pages/Tools/index').default,
            "exact": true
          },
          {
            "path": "/aigc2/ResourceUpload",
            "component": require('@/pages/aigc/pages/ResourceUpload/index').default,
            "exact": true
          },
          {
            "path": "/aigc2/report-summary",
            "component": require('@/pages/aigc/pages/reportSummary/index').default,
            "exact": true
          },
          {
            "path": "/aigc2/Text2SQL",
            "component": require('@/pages/aigc/pages/Text2SQL/index').default,
            "exact": true
          },
          {
            "path": "/aigc2/GPTTranslator",
            "component": require('@/pages/aigc/pages/GPTTranslator/index').default,
            "exact": true
          },
          {
            "path": "/aigc2/motion-capture",
            "component": require('@/pages/aigc/pages/MotionCapture/index').default,
            "exact": true
          }
        ]
      },
      {
        "path": "/agent",
        "component": require('@/pages/aigc/layouts/agentLayout/index').default,
        "routes": [
          {
            "path": "/agent/home",
            "component": require('@/pages/aigc/pages/Agent/Home/index').default,
            "exact": true
          },
          {
            "path": "/agent/collection",
            "component": require('@/pages/aigc/pages/Agent/AgentCollection/index').default,
            "exact": true
          },
          {
            "path": "/agent/skills/:skillId",
            "component": require('@/pages/aigc/pages/Agent/SkillsCollection/SkillDetail/index').default,
            "exact": true
          },
          {
            "path": "/agent/skills",
            "component": require('@/pages/aigc/pages/Agent/SkillsCollection/index').default,
            "exact": true
          },
          {
            "path": "/agent/files",
            "component": require('@/pages/aigc/pages/Agent/FileLibrary/index').default,
            "exact": true
          },
          {
            "path": "/agent/chat",
            "component": require('@/pages/aigc/pages/Agent/ChatPage/index').default,
            "exact": true
          },
          {
            "path": "/agent/chatShare",
            "component": require('@/pages/aigc/pages/Agent/ChatShare/index').default,
            "exact": true
          },
          {
            "path": "/agent/tempPool",
            "component": require('@/pages/aigc/pages/Agent/ChatShare/index').default,
            "exact": true
          },
          {
            "path": "/agent/testBiData",
            "component": require('@/pages/aigc/pages/testBiData/index').default,
            "exact": true
          },
          {
            "component": require('@/pages/globalpedia/pages/NotFoundPage').default,
            "exact": true
          }
        ]
      },
      {
        "path": "/benchmark",
        "component": require('@/pages/benchmark/layouts/index').default,
        "routes": [
          {
            "path": "/benchmark/:frameType",
            "routes": [
              {
                "path": "/benchmark/:frameType/tableau/report/:reportId",
                "component": require('@/pages/benchmark/pages/report/tableau').default,
                "exact": true
              },
              {
                "path": "/benchmark/:frameType/preset/report/:reportId",
                "component": require('@/pages/benchmark/pages/report/preset').default,
                "exact": true
              },
              {
                "path": "/benchmark/:frameType/pdf/report/:reportId",
                "component": require('@/pages/benchmark/pages/report/pdf').default,
                "exact": true
              },
              {
                "path": "/benchmark/:frameType/cos/report/:reportId",
                "component": require('@/pages/benchmark/pages/report/cos').default,
                "exact": true
              },
              {
                "path": "/benchmark/:frameType/datalab/customDashboard/:dashboardId",
                "component": require('@/pages/benchmark/pages/report/datalab').default,
                "exact": true
              },
              {
                "path": "/benchmark/:frameType/looker/report/:reportId",
                "component": require('@/pages/benchmark/pages/report/looker').default,
                "exact": true
              },
              {
                "path": "/benchmark/:frameType/web/report/:reportId",
                "component": require('@/pages/benchmark/pages/report/web').default,
                "exact": true
              },
              {
                "path": "/benchmark/:frameType/authPath/report/:reportId",
                "component": require('@/pages/benchmark/pages/report/auth').default,
                "exact": true
              },
              {
                "path": "/benchmark/:frameType/explore",
                "component": require('@/pages/benchmark/pages/explore').default,
                "exact": true
              },
              {
                "path": "/benchmark/:frameType/explore/metricDetail/:metric",
                "component": require('@/pages/benchmark/pages/metricDetail').default,
                "exact": true
              },
              {
                "path": "/benchmark/:frameType/explore/metricOtdr/:metric",
                "component": require('@/pages/benchmark/pages/metricOtdr').default,
                "exact": true
              },
              {
                "path": "/benchmark/:frameType/explore/metricIaa/:metric",
                "component": require('@/pages/benchmark/pages/metricIaa').default,
                "exact": true
              },
              {
                "path": "/benchmark/:frameType/explore/metricTips/:metric",
                "component": require('@/pages/benchmark/pages/metricTip').default,
                "exact": true
              },
              {
                "path": "/benchmark/:frameType/genre",
                "component": require('@/pages/benchmark/pages/genre').default,
                "exact": true
              },
              {
                "path": "/benchmark/:frameType/IAABenchmarks",
                "component": require('@/pages/benchmark/pages/iaaBenchmarks').default,
                "exact": true
              }
            ]
          }
        ]
      },
      {
        "path": "/strategic",
        "component": require('@/pages/strategic/layout/index').default,
        "routes": [
          {
            "path": "/strategic/home",
            "component": require('@/pages/strategic/pages/home/index').default,
            "routes": [
              {
                "path": "/strategic/home/business",
                "component": require('@/pages/strategic/pages/BusinessManagement/index').default,
                "exact": true
              },
              {
                "path": "/strategic/home/studio",
                "component": require('@/pages/strategic/pages/StudioManagement/index').default,
                "exact": true
              },
              {
                "path": "/strategic/home/publishing",
                "component": require('@/pages/strategic/pages/PublishingManagement/index').default,
                "exact": true
              }
            ]
          },
          {
            "path": "/strategic/*",
            "component": require('@/pages/home/pages/NotFound/index').default,
            "exact": true
          }
        ]
      },
      {
        "path": "/user-center",
        "component": require('@/pages/user-center/layout/index').default,
        "routes": [
          {
            "path": "/user-center/year-report",
            "component": require('@/pages/user-center/pages/YearReport').default,
            "exact": true
          },
          {
            "path": "/user-center/user-data-center",
            "component": require('@/pages/user-center/pages/UserDataCenter').default,
            "routes": [
              {
                "path": "/user-center/user-data-center/quarter-report",
                "component": require('@/pages/user-center/pages/UserDataCenter/QuarterReport').default,
                "exact": true
              },
              {
                "path": "/user-center/user-data-center/",
                "redirect": "/user-center/user-data-center/quarter-report",
                "exact": true
              },
              {
                "path": "/user-center/user-data-center/*",
                "redirect": "/user-center/user-data-center/quarter-report",
                "exact": true
              }
            ]
          },
          {
            "path": "/user-center/content-management-center/reports/market-reports/add",
            "component": require('@/pages/user-center/pages/ContentManagementCenter/Reports/MarketReports/Add').default,
            "exact": true
          },
          {
            "path": "/user-center/content-management-center/reports/market-reports/edit",
            "component": require('@/pages/user-center/pages/ContentManagementCenter/Reports/MarketReports/Edit').default,
            "exact": true
          },
          {
            "path": "/user-center/content-management-center/reports/add",
            "component": require('@/pages/user-center/pages/ContentManagementCenter/Reports/Add').default,
            "exact": true
          },
          {
            "path": "/user-center/content-management-center/reports/edit",
            "component": require('@/pages/user-center/pages/ContentManagementCenter/Reports/Edit').default,
            "exact": true
          },
          {
            "path": "/user-center/content-management-center",
            "component": require('@/pages/user-center/pages/ContentManagementCenter').default,
            "routes": [
              {
                "path": "/user-center/content-management-center/reports",
                "component": require('@/pages/user-center/pages/ContentManagementCenter/Reports').default,
                "exact": true
              },
              {
                "path": "/user-center/content-management-center",
                "redirect": "/user-center/content-management-center/reports",
                "exact": true
              },
              {
                "path": "/user-center/content-management-center/*",
                "redirect": "/user-center/content-management-center/reports",
                "exact": true
              }
            ]
          },
          {
            "path": "/user-center/personal-tokens-center",
            "component": require('@/pages/user-center/pages/PersonalTokensCenter').default,
            "exact": true
          },
          {
            "path": "/user-center",
            "redirect": "/user-center/content-management-center/reports",
            "exact": true
          },
          {
            "path": "/user-center/*",
            "component": require('@/pages/home/pages/NotFound/index').default,
            "exact": true
          }
        ]
      },
      {
        "path": "/404",
        "component": require('@/pages/home/pages/NotFound/index').default,
        "exact": true
      },
      {
        "path": "/*",
        "redirect": "/404",
        "exact": true
      },
      {
        "component": require('@/pages/home/pages/NotFound/index').default
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
